import { Globals } from './../../globals';
import { Directive, Input, OnInit } from '@angular/core';
import { Utils } from 'src/app/shared/utils/utils';
import { FileUtils } from 'src/app/shared/utils/file-utils';
import { downloadData } from 'aws-amplify/storage';

@Directive({
  selector: '[appImageViewerWrapper]'
})
export class ImageViewerWrapperDirective implements OnInit {
  @Input() path = ''
  @Input() id = 0
  @Input() field = ''

  image: any
  loading = false
  globals = Globals

  ngOnInit() {
    this.onInit()
  }

  onInit() {
    if (this.id > 0) {
      this.loading = true
      downloadData(
        {
          path: `main/${this.path}/${this.id}/${this.field}/resource.png`
        }
      )
        .result
        .then(result => {
        FileUtils.imageFromBlob(result.body).then(image => this.image = image)
        this.loading = false
      }).catch(err => {
        this.loading = false
        Utils.error(err)
      })
    }
  }

}
